import { accountDefaultConfig, accountFeatures } from './account';
import { adminDefaultConfig, adminFeatures } from './admin';
import { articleDefaultConfig, articleFeatures } from './article';
import { articleQuestionsDefaultConfig } from './articlequestions';
import { componentDemoDefaultConfig, componentDemoFeatures } from './componentdemo';
import { editorialDashDefaultConfig, editorialDashFeatures } from './editorial-dash';
import type { FeatureGroup } from './feature-helpers';
import { loginFeatures } from './login';
import { modDashboardDefaultConfig, modDashboardFeatures } from './moddash';
import { moderationDashDefaultConfig, moderationDashFeatures } from './moderationdash';
import { profileDefaultConfig, profileFeatures } from './profile';
import { questionDefaultConfig, questionFeatures } from './question';
import { simpleCommentsDefaultConfig, simpleCommentsFeatures } from './simplecomments';
import { topicDefaultConfig, topicFeatures } from './topic';

export const features: Record<string, FeatureGroup[]> = {
    account: accountFeatures,
    admin: adminFeatures,
    article: articleFeatures,
    componentdemo: componentDemoFeatures,
    moddashboard: modDashboardFeatures,
    editorialdash: editorialDashFeatures,
    login: loginFeatures,
    moderationdash: moderationDashFeatures,
    profile: profileFeatures,
    question: questionFeatures,
    simplecomments: simpleCommentsFeatures,
    topic: topicFeatures,
};

export const defaultFeatureConfig = {
    account: accountDefaultConfig,
    admin: adminDefaultConfig,
    article: articleDefaultConfig,
    articlequestions: articleQuestionsDefaultConfig,
    componentdemo: componentDemoDefaultConfig,
    moddashboard: modDashboardDefaultConfig,
    moderationdash: moderationDashDefaultConfig,
    profile: profileDefaultConfig,
    simplecomments: simpleCommentsDefaultConfig,
    question: questionDefaultConfig,
    editorialdash: editorialDashDefaultConfig,
    topic: topicDefaultConfig,
};

export const newFeatures = {};
